<template>
    <div>
        <DCard
            padding
        >
            <FilesForm
                :customer-id="customerId"
                :psa-orders="psaOrders"
                :errors="errors"
                @submit="storeFile"
            />
        </DCard>
    </div>
</template>

<script>
import CustomerBase from '~@/Pages/Customers/Base'
import App from '~@/App.vue'

import FilesForm from '~@/Components/Customers/Files/Form'

export default {
    name: 'CustomerFilesCreate',
    components: {
        FilesForm
    },
    layout: [App, CustomerBase],
    props: {
        errors: {
            type: Object,
            default: () => {
                return {}
            }
        },
        customerId: {
            type: Number,
            default: 0
        },
        psaOrders: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    methods: {
        storeFile (form) {
            form.post(this.$route('customers.customers.customer-files.store', {
                customer: this.customerId
            }))
        }
    }
}
</script>
